import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import frTranslation from '../../public/locales/fr/translation.json';
import enTranslation from '../../public/locales/en/translation.json';

// Translations are bundled statically (static imports above) so they are
// available synchronously when init() runs. This prevents the "key shown
// instead of translated text" issue that occurred on direct page access or
// refresh — when the async fetch approach races against React's first render.
const defaultLanguage = import.meta.env.VITE_DEFAULT_LANGUAGE || 'fr';

i18n.use(initReactI18next).init({
  lng: defaultLanguage,
  fallbackLng: 'fr',
  debug: import.meta.env.VITE_APP_ENV === 'development',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    fr: { translation: frTranslation },
    en: { translation: enTranslation },
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
